export function gallesPropertiesReferralAgreement() {
return [   //2024 Release 2025-11-07 20:11:18
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.6,
   left: 123.36,
   width: 166.20,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.6,
   left: 343.68,
   width: 197.88,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 146.12,
   left: 131.52,
   width: 410.04,
   height: 11.978
}
,
{
   page: 0,
   name: "City", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 163.64,
   left: 92.16,
   width: 197.40,
   height: 11.978
}
,
{
   page: 0,
   name: "StateProv", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 163.64,
   left: 334.32,
   width: 24.60,
   height: 11.978
}
,
{
   page: 0,
   name: "ZipPC", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 163.64,
   left: 400.8,
   width: 32.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Country", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 163.64,
   left: 468.96,
   width: 72.60,
   height: 11.978
}
,
{
   page: 0,
   name: "Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 181.16,
   left: 130.8,
   width: 410.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.44,
   left: 141.6,
   width: 75.96,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.44,
   left: 273.6,
   width: 87.96,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.44,
   left: 407.52,
   width: 134.04,
   height: 11.978
}
,
{
   page: 0,
   name: "Agent Name_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.24,
   left: 123.36,
   width: 166.20,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Name_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.24,
   left: 343.68,
   width: 197.88,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 274.76,
   left: 131.52,
   width: 410.04,
   height: 11.978
}
,
{
   page: 0,
   name: "City_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.28,
   left: 92.16,
   width: 197.40,
   height: 11.978
}
,
{
   page: 0,
   name: "StateProv_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.28,
   left: 334.32,
   width: 24.60,
   height: 11.978
}
,
{
   page: 0,
   name: "ZipPC_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.28,
   left: 400.8,
   width: 32.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Country_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.28,
   left: 468.96,
   width: 72.60,
   height: 11.978
}
,
{
   page: 0,
   name: "Address_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 309.8,
   left: 130.8,
   width: 410.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.08,
   left: 141.6,
   width: 75.96,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.08,
   left: 273.6,
   width: 87.96,
   height: 11.978
}
,
{
   page: 0,
   name: "ce Fax_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327.08,
   left: 407.52,
   width: 134.04,
   height: 11.978
}
,
{
   page: 0,
   name: "Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 385.88,
   left: 109.44,
   width: 218.52,
   height: 11.978
}
,
{
   page: 0,
   name: "Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 385.88,
   left: 369.6,
   width: 171.96,
   height: 11.978
}
,
{
   page: 0,
   name: "Address_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.4,
   left: 108.0,
   width: 433.56,
   height: 11.978
}
,
{
   page: 0,
   name: "City_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.92,
   left: 92.16,
   width: 197.40,
   height: 11.978
}
,
{
   page: 0,
   name: "StateProv_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.8,
   left: 334.32,
   width: 24.60,
   height: 11.978
}
,
{
   page: 0,
   name: "ZipPC_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.8,
   left: 400.8,
   width: 32.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Country_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.8,
   left: 468.96,
   width: 72.60,
   height: 11.978
}
,
{
   page: 0,
   name: "Address_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 438.2,
   left: 130.8,
   width: 410.76,
   height: 11.978
}
,
{
   page: 0,
   name: "Phone_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.72,
   left: 118.08,
   width: 99.48,
   height: 11.978
}
,
{
   page: 0,
   name: "Home Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.72,
   left: 274.08,
   width: 87.48,
   height: 11.978
}
,
{
   page: 0,
   name: "Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.72,
   left: 388.56,
   width: 153.00,
   height: 11.978
}
,
{
   page: 0,
   name: "on", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 473.24,
   left: 182.64,
   width: 358.92,
   height: 11.978
}
,
{
   page: 0,
   name: "ng Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.32,
   left: 321.84,
   width: 22.80,
   height: 11.978
}
,
{
   page: 0,
   name: "sted here OR other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 584.84,
   left: 318.0,
   width: 187.44,
   height: 11.978
}
,
{
   page: 0,
   name: "begin on Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.64,
   left: 425.88,
   width: 18.84,
   height: 11.978
}
,
{
   page: 0,
   name: "and expire on Date", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.64,
   left: 519.36,
   width: 18.72,
   height: 11.978
}
,
{
   page: 0,
   name: "signature broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 652.039,
   left: 74.6185,
   width: 150.0005,
   height: 13.491
}
,
{
   page: 0,
   name: "signature receivingBroker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.5848,
   left: 73.0003,
   width: 149.9997,
   height: 13.4909
}
,
{
   page: 0,
   name: "signature referringEmplBroker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 652.039,
   left: 323.656,
   width: 150.000,
   height: 13.491
}
,
{
   page: 0,
   name: "signature receivingEmplBroker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.5848,
   left: 324.965,
   width: 150.000,
   height: 13.4909
}
,
{
   page: 0,
   name: "date brokerSign", 
   fontSize: 9,
   type: "date",
   top: 652.039,
   left: 227.874,
   width: 72.763,
   height: 13.491
}
,
{
   page: 0,
   name: "date receivingBrokerSign", 
   fontSize: 9,
   type: "date",
   top: 694.5848,
   left: 226.565,
   width: 72.763,
   height: 13.4909
}
,
{
   page: 0,
   name: "date referringEmplBrokerSign", 
   fontSize: 9,
   type: "date",
   top: 652.694,
   left: 477.0,
   width: 72.763,
   height: 12.836
}
,
{
   page: 0,
   name: "date receivingEmplBrokerSign", 
   fontSize: 9,
   type: "date",
   top: 694.5848,
   left: 477.0,
   width: 72.763,
   height: 13.4909
}
,
{
   page: 0,
   name: "Text9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 748.767,
   left: 125.019,
   width: 100.254,
   height: 10.8726
}
,
{
   page: 0,
   name: "Text10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 748.1487,
   left: 312.22,
   width: 218.073,
   height: 12.1818
}
,
{
   page: 0,
   name: "Text11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 488.293,
   left: 73.964,
   width: 466.147,
   height: 12.836
}
] }
